export default __webpack_public_path__ + "static/media/orbit.004771f7.svg";